import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { MedSwitchComponent } from "./med-switch.component";
import { MedLabelModule } from "../med-label/med-label.module";

@NgModule({
  declarations: [
    MedSwitchComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MedLabelModule,
  ],
  exports: [
    MedSwitchComponent,
  ],
})
export class MedSwitchModule { }
